import React from 'react'

const minus = ({ width = '14', height = '5', className = '' }) => (
  <svg width={width} height={height} viewBox="0 0 14 5" className={className}>
    <g id="BAD" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="sidebar-cards-bad"
        transform="translate(-3649.000000, -436.000000)"
        fill="#FCC5C0"
        fillRule="nonzero"
        stroke="#F63C2C"
        strokeWidth="0.75">
        <g id="badGroup" transform="translate(3650.000000, 437.000000)">
          <path
            d="M1.33333333,2.66666667 L10.6666667,2.66666667 C11.4030463,2.66666667 12,2.069713 12,1.33333333 C12,0.596953667 11.4030463,0 10.6666667,0 L1.33333333,0 C0.596953667,0 0,0.596953667 0,1.33333333 C0,2.069713 0.596953667,2.66666667 1.33333333,2.66666667 Z"
            id="badPath-19"
          />
        </g>
      </g>
    </g>
  </svg>
)

export default minus
